/**
 * @class PriceChangeIndicatorTypes
 * @name types
 * @memberof Mojito.Presentation.Components.PriceChangeIndicator
 */
export default class PriceChangeIndicatorTypes {}

/**
 * Enum for PRICE_CHANGE_STATES, determining the direction of the price change.
 *
 * @typedef PRICE_CHANGE_STATES
 * @property {string} INCREASE - Price increase.
 * @property {string} DECREASE - Price decrease.
 * @property {string} NONE - Price not changed.
 * @memberof Mojito.Presentation.Components.PriceChangeIndicator.types
 */
PriceChangeIndicatorTypes.PRICE_CHANGE_STATES = {
    INCREASE: 'increase',
    DECREASE: 'decrease',
    NONE: 'none',
};
